import * as React from 'react';

import classnames from 'classnames';

import {AnnualSavingsPill} from 'shells/billing/add-ons/annual-savings-pill';
import type {Cycle} from 'shells/billing/types';
import {SegmentedControl} from 'shells/card/segmented-control';
import type {ControlOption} from 'shells/card/segmented-control';

import {CycleControl} from './cycle-control';
import {getDisabledCyclePopoverText} from './helpers';
import {NumUsersInput} from './num-users-input';
import {SuiteTitle} from './suite-title';

import styles from './suite-header.module.css';

type Props = {
    selectedCycle?: Cycle;
    numUsers?: string;
    numEnabledUsers?: number | null | undefined;
    numSalesUsers?: string;
    numMarketingLicenses?: number | null | undefined;
    numEnabledLicenses?: number | null | undefined;
    isTrial?: boolean;
    hasUsersInput?: boolean;
    onCycleChange?: (cycle: Cycle) => void;
    onNumUsersChange?: (numUsers: string) => void;
    isMonthlyOnly?: boolean;
    suite: 'sales' | 'marketing' | 'engagement';
    hideUsersInput?: boolean;
};

export function SuiteHeader(props: Props) {
    const userInputDisabled = props.hasUsersInput === false;

    const CYCLE_CONTROLS: ControlOption<Cycle>[] = [
        {
            value: 'MONTHLY',
            content: <CycleControl title='Pay monthly' height={35} />,
        },
        {
            value: 'ANNUALLY',
            content: <CycleControl title='Pay annually' height={35} />,
            isDisabled: props.isMonthlyOnly,
            disabledPopoverText: getDisabledCyclePopoverText(props.suite),
        },
    ];

    const optionsStyleName = classnames(styles.options, {
        [styles['marketing-options']]: props.suite === 'marketing',
        [styles['sales-options']]: props.suite === 'sales',
        [styles['engagement-options']]: props.suite === 'engagement',
    });

    return (
        <div className={styles.header}>
            <SuiteTitle suite={props.suite} />
            <div className={optionsStyleName}>
                {!props.hideUsersInput && (
                    <NumUsersInput
                        numUsers={props.numUsers ? props.numUsers : ''}
                        numEnabledUsers={props.numEnabledUsers}
                        numSalesUsers={props.numSalesUsers ? props.numSalesUsers : ''}
                        numMarketingLicenses={props.numMarketingLicenses}
                        numEnabledLicenses={props.numEnabledLicenses}
                        isTrial={props.isTrial ? props.isTrial : false}
                        disabled={userInputDisabled}
                        onNumUsersChange={props.onNumUsersChange}
                        suite={props.suite}
                    />
                )}
                <div className='flex align-center gap-16'>
                    {!props.isMonthlyOnly && <AnnualSavingsPill savings='15%' />}
                    <SegmentedControl
                        buttonOptions={CYCLE_CONTROLS}
                        selectedValue={props.selectedCycle ? props.selectedCycle : 'MONTHLY'}
                        setSelectedValue={(value) =>
                            props.onCycleChange && props.onCycleChange(value)
                        }
                    />
                </div>
            </div>
        </div>
    );
}
